import RegistrationSection from "../Components/RegistrationSection";
import Title from "../Common/Title";
import { Flex } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { useWrapper } from "../Context/WrapperContext";

export default function Registration() {
  const [title, setTitle] = useState("");

  const { forceSetIndex } = useWrapper();

  useEffect(() => {
    // Get the query parameters from the location object
    const queryString = window.location.search;
    const queryParams = new URLSearchParams(queryString);

    // Access a specific query parameter by its name
    const param = queryParams.get("claimsexchange");
    if (param === "ForgotPassword") {
      setTitle("Password Reset Request");
    } else {
      setTitle("Create a MySGI Account");
    }
  }, []);

  useEffect(() => {
    let url = window.location.href;
    let components = url.split("/");

    let lastComponent = components[components.length - 1];

    // if email is confirmed - skip to set password
    if (lastComponent.startsWith("confirmed")) {
      forceSetIndex(1);
    }
  }, [forceSetIndex]);

  return (
    <Flex direction="column" maxW={468} mx="auto">
      <Title text={title} />
      <RegistrationSection />
    </Flex>
  );
}
